/// <amd-module name="typeahead/core/geolocation/message/GeolocationRequestMessage" />

import {TypeaheadMessage} from "typeahead/core/message/TypeaheadMessage";

export class GeolocationRequestMessage implements TypeaheadMessage {

    public static getTopic(): string {
        return "typeahead.geolocation_request";
    }

    constructor(private domElementId: string) {}

    public getTopic(): string {
        return GeolocationRequestMessage.getTopic();
    }

    public getDomElementId(): string {
        return this.domElementId;
    }
}
